import Vue from 'vue';
import Vuex from 'vuex';

// import actions from './store/actions';
import currentUser from './store/modules/currentUser';
import notification from './store/modules/notification';
import siteStats from './store/modules/siteStats';

import accessory from './store/modules/accessory';
import bodyColor from './store/modules/bodyColor';
import brand from './store/modules/brand';
import category from './store/modules/category';
import character from './store/modules/character';
import comment from './store/modules/comment';
import country from './store/modules/country';
import favorite from './store/modules/favorite';
import favoriteList from './store/modules/favoriteList';
import flag from './store/modules/flag';
import generation from './store/modules/generation';
import grouping from './store/modules/grouping';
import hairColor from './store/modules/hairColor';
import herd from './store/modules/herd';
import herdItem from './store/modules/herdItem';
import image from './store/modules/image';
import manufacturer from './store/modules/manufacturer';
import mold from './store/modules/mold';
import origin from './store/modules/origin';
import pony from './store/modules/pony';
import pose from './store/modules/pose';
import question from './store/modules/question';
import release from './store/modules/release';
import role from './store/modules/role';
import signupCode from './store/modules/signupCode';
import theme from './store/modules/theme';
import user from './store/modules/user';
import wishlist from './store/modules/wishlist';
import wishlistItem from './store/modules/wishlistItem';
import year from './store/modules/year';
import herdStats from './store/modules/herdStats';
import activity from './store/modules/activity';
// import createLogger from './plugins/logger';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  // actions,
  modules: {
    accessory,
    bodyColor,
    brand,
    category,
    character,
    comment,
    country,
    currentUser,
    favorite,
    favoriteList,
    flag,
    generation,
    grouping,
    hairColor,
    herd,
    herdItem,
    image,
    manufacturer,
    mold,
    notification,
    origin,
    pony,
    pose,
    question,
    release,
    role,
    signupCode,
    siteStats,
    theme,
    user,
    wishlist,
    wishlistItem,
    year,
    herdStats,
    activity
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
});
